import { render } from "./NcrmWorkflowFileRequestContentEditor.vue?vue&type=template&id=79be52ba&scoped=true"
import script from "./NcrmWorkflowFileRequestContentEditor.vue?vue&type=script&lang=js"
export * from "./NcrmWorkflowFileRequestContentEditor.vue?vue&type=script&lang=js"

import "./NcrmWorkflowFileRequestContentEditor.css?vue&type=style&index=0&id=79be52ba&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79be52ba"]])

export default __exports__